import React from 'react';

function SOFFieldsDisplay({ sofData, onCompareToChargebee }) {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-6">
        Sales Order Form - Extracted Fields
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-4">
          <h3 className="text-md font-medium text-gray-900 border-b pb-2">Contact Information</h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700">Billing Contact Name</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.billing_contact_information?.contact_name || 'N/A'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Shipping Contact Name</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.shipping_contact_information?.contact_name || 'N/A'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Customer/Organization</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.billing_contact_information?.customer || 'N/A'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Billing Email Address</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.billing_contact_information?.email_address || 'N/A'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Shipping Email Address</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.shipping_contact_information?.email_address || 'N/A'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Billing Phone</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.billing_contact_information?.phone || 'N/A'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Shipping Phone</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.shipping_contact_information?.phone || 'N/A'}</p>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <h3 className="text-md font-medium text-gray-900 border-b pb-2">Bill-To Address</h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700">Billing Address</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded whitespace-pre-wrap">{sofData.billing_contact_information?.bill_to_address || 'N/A'}</p>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <h3 className="text-md font-medium text-gray-900 border-b pb-2">Ship-To Address</h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700">Shipping Address</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded whitespace-pre-wrap">{sofData.shipping_contact_information?.bill_to_address || 'N/A'}</p>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <h3 className="text-md font-medium text-gray-900 border-b pb-2">Subscription Details</h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700">Subscription Start Date</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.subscription_details?.subscription_term_start_date || 'N/A'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Subscription End Date</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.subscription_details?.subscription_term_end_date || 'N/A'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Subscription Term</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.subscription_details?.subscription_term || 'N/A'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Billing Frequency</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.subscription_details?.billing_frequency || 'N/A'}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        <div className="space-y-4">
          <h3 className="text-md font-medium text-gray-900 border-b pb-2">Purchase Order & Payment</h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700">PO Number Required</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.subscription_details?.po_number_required_on_invoice || 'N/A'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">PO Number</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.subscription_details?.po_number || 'N/A'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Payment Method</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.subscription_details?.payment_method || 'N/A'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Payment Terms</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.subscription_details?.payment_terms || 'N/A'}</p>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <h3 className="text-md font-medium text-gray-900 border-b pb-2">Tax Information</h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700">Applicable Tax Registration</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.subscription_details?.applicable_tax_registration || 'N/A'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Tax Registration ID</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.subscription_details?.tax_registration_id || 'N/A'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Is Tax Exempt</label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.subscription_details?.is_tax_exempt || 'N/A'}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h3 className="text-md font-medium text-gray-900 border-b pb-2 mb-4">Product Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Product Instance ID</label>
            <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.product_information?.product_instance_id || 'N/A'}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Product Instance Domain</label>
            <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.product_information?.product_instance_domain || 'N/A'}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">No. Of Users</label>
            <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.product_information?.no_of_users || 'N/A'}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Type</label>
            <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.product_information?.type || 'N/A'}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Item Name</label>
            <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.product_information?.item_name || 'N/A'}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">List Price</label>
            <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.product_information?.list_price || 'N/A'}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Net Price/Unit</label>
            <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.product_information?.net_price_unit || 'N/A'}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Duration (Months)</label>
            <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.product_information?.duration_months || 'N/A'}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Quantity</label>
            <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">{sofData.product_information?.quantity || 'N/A'}</p>
          </div>
        </div>
        
        <div className="mt-6 bg-blue-50 p-4 rounded-lg">
          <div className="flex justify-between items-start">
            <div>
              <label className="block text-lg font-semibold text-gray-900">Total Net Price</label>
              <p className="text-2xl font-bold text-blue-800">{sofData.product_information?.total_net_price || 'N/A'}</p>
            </div>
            <button
              onClick={onCompareToChargebee}
              className="bg-orange-500 hover:bg-orange-600 text-white font-medium px-4 py-2 rounded-lg transition-colors"
            >
              Compare SOF to ChargeBee Subscription
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SOFFieldsDisplay;